import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Loader2 from '../../components/loader/Loader2';
import { toast } from 'react-toastify';
import './style.css';
import { getPackageByUserId, updatePackageStatus } from '../../../services/Admin';

function EditPackage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const packageId = params.get('packageId');

  const [packageData, setPackageData] = useState(null);
  const [status, setStatus] = useState('');
  const [isPending, setIsPending] = useState(false);

  // Fetch package data on component mount
  useEffect(() => {
    const fetchPackage = async () => {
      if (!packageId) return;
      
      setIsPending(true);
      try {
        const response = await getPackageByUserId(packageId);
        if (response) {
          setPackageData(response);
          setStatus(response.status);
          toast.success("Package loaded successfully");
        } else {
          toast.error("Package not found");
        }
      } catch (error) {
        toast.error("Failed to load package");
        console.error(error);
      } finally {
        setIsPending(false);
      }
    };

    fetchPackage();
  }, [packageId]);

  const handleStatusUpdate = async () => {
    if (!packageId || !status) {
      toast.warn("Please select a status");
      return;
    }

    setIsPending(true);
    try {
      await updatePackageStatus(packageId, status);
      toast.success("Package status updated successfully");
      // Refresh package data
      const response = await getPackageByUserId(packageId);
      setPackageData(response);
      setStatus(response.status);
    } catch (error) {
      toast.error("Failed to update package status");
      console.error(error);
    } finally {
      setIsPending(false);
    }
  };

  if (isPending) {
    return <Loader2 />;
  }

  if (!packageData) {
    return (
      <div className="edit-package">
        <h1 className="main-heading">Edit Package</h1>
        <p>Loading package data...</p>
      </div>
    );
  }

  return (
    <div className="edit-package">
      <h1 className="main-heading">Edit Package</h1>

      <div className="adpa-first">
        <div className="adpafi-top">
          <h2>Package Information</h2>
        </div>
        <div className="adpafi-body">
          <div className="input-group">
            <label>Package ID:</label>
            <span className="value">{packageData.packageId}</span>
          </div>
          <div className="input-group">
            <label>User ID:</label>
            <span className="value">{packageData.userId}</span>
          </div>
          <div className="input-group">
            <label>Current Status:</label>
            <span className={`status ${packageData.status.toLowerCase()}`}>
              {packageData.status}
            </span>
          </div>
        </div>
      </div>

      <div className="adpa-first">
        <div className="adpafi-top">
          <h2>Update Status</h2>
        </div>
        <div className="adpafi-body">
          <div className="input-group">
            <label>New Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Requested">Requested</option>
            </select>
          </div>
          <div className="button-group">
            <button
              onClick={handleStatusUpdate}
              disabled={status === packageData.status}
            >
              Update Status
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPackage;